<template>
  <div class="stat_top">
    <div class="top1">
      <div class="item">
        <div class="title">累计入口点击次数</div>
        <div class="value">{{ overallStatis.clickPV || 0 }}</div>
      </div>
      <div class="h-line" />
      <div class="item">
        <div class="title">累计观看人次</div>
        <div class="value">{{ overallStatis.watchPV || 0 }}</div>
      </div>
      <div class="h-line" />
      <div class="item">
        <div class="title">累计入口点击人数</div>
        <div class="value">{{ overallStatis.clickUV || 0 }}</div>
      </div>
      <div class="h-line" />
      <div class="item">
        <div class="title">累计观看人数</div>
        <div class="value">{{ overallStatis.watchUV || 0 }}</div>
      </div>
      <div class="h-line" />
      <div class="item">
        <div class="title">预约用户参与率</div>
        <div class="value">{{ overallStatis.ticketUserRate || '0.00%' }}</div>
      </div>
      <div class="h-line" />
      <div class="item">
        <div class="title">直播名单用户参与率</div>
        <div class="value">{{ overallStatis.liveUserRate || '0.00%' }}</div>
      </div>
    </div>
    <div class="top2">
      <div class="item mr-17">
        <div class="item-top">
          <div class="top-left">
            <img src="@/assets/image/statistics/icon_online_count.png">
            <div class="title red">在线最高并发</div>
          </div>
          <div class="tips">数据来自咪咕，延迟1小时左右更新</div>
        </div>
        <span class="value">
          {{ miguStatistics.maxOnline || 0 }}
          <div class="value-right">人</div>
        </span>
      </div>
      <div class="item mr-17">
        <div class="item-top">
          <div class="top-left">
            <img src="@/assets/image/statistics/icon_like_count.png">
            <div class="title orange">点赞次数</div>
          </div>
          <div class="tips">数据来自咪咕，延迟1小时左右更新</div>
        </div>
        <span class="value">
          {{ miguStatistics.thumbNum || 0 }}
          <div class="value-right">次</div>
        </span>
      </div>
      <div class="item">
        <div class="item-top">
          <div class="top-left">
            <img src="@/assets/image/statistics/icon_net_count.png">
            <div class="title blue">累计消耗流量</div>
          </div>
          <div class="tips">数据来自咪咕，延迟1小时左右更新</div>
        </div>
        <span class="value">
          {{ miguStatistics.formatFlow || 0 }}
          <div class="value-right num-right">GB</div>
        </span>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  components: {  },
  props: {
    overallStatis: {
      type: Object,
      default: () => {},
    },
    miguStatistics: {
      type: Object,
      default: () => {},
    },
    
  },
  data() {
    return {};
  },
  created() {},
  activated() {},
  computed: {},
  methods: {},
};
</script>
<style lang='scss' scoped>

.top1 {
  background: #F9FBFF;
  border-radius: 4px;
  opacity: 1;
  border: 1px solid rgba(0,0,0,0.04);
  display: flex;
  align-items: center;
  height: 108px;
  .item {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
    .title {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      margin-bottom: 12px;

    }
    .value {
      font-size: 28px;
      font-family: "DIN-PRO BOLD";
      font-weight: bold;
      color: #0A1D4D;
    }
  }

  .h-line {
    width: 0;
    height: 48px;
    opacity: 1;
    border: 1px solid #EBECF0;
  }

}

.top2 {
  margin-top: 16px;
  display: flex;

  .item {
    flex: 1;
    background: #F9FBFF;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid rgba(0,0,0,0.04);
    padding: 24px 16px 22px 32px;
    &-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .top-left {
        display: flex;
        align-items: center;
        img {
          width: 24px;
          height: 24px;
          margin-right: 8px;
        }
        .title {
          font-size: 14px;
          font-weight: bold;
          line-height: 20px;
          width: 100px;
        }
      }
      
      .red {
        color: #F06262;
      }
      .orange {
        color: #FA8B3A;
      }
      .blue {
        color: #3893E7;
      }
      .tips {
        font-size: 12px;
        font-weight: 400;
        color: #A9A9AA;
        line-height: 16px;
        text-align: end;
      }
    }
    .value {
      margin-top: 12px;
      font-size: 28px;
      font-family: "DIN-PRO BOLD";
      font-weight: bold;
      color: #222E4C;
      line-height: 32px;
      display: flex;
      align-items: flex-end;
      &-right {
        margin-left: 4px;
        font-size: 14px;
        font-weight: 500;
        color: #222E4C;
        line-height: 24px;
        
      }
      .num-right {
        line-height: 22px;
      }
    }
  }
}
.mr-17 {
  margin-right: 17px;
}


</style>